import type { MetalCommitment } from "@warrenio/api-spec/spec.oats.gen";

export interface MetalCommitmentWithEndsAt extends MetalCommitment {
    ends_at: string;
}

export function getCurrentCommitment(
    commitments: MetalCommitment[],
    leaseUuid: string,
): MetalCommitmentWithEndsAt | null {
    for (const commitment of commitments) {
        const currentCoverage = commitment.coverages.find(
            (coverage) => coverage.metal_lease_uuid === leaseUuid && coverage.temporal_status === "current",
        );
        if (currentCoverage) {
            return { ...commitment, ends_at: currentCoverage.ends_at };
        }
    }

    return null;
}

export function hasFutureCommitment(commitments: MetalCommitment[], leaseUuid: string): boolean {
    return commitments.some((commitment) =>
        commitment.coverages.some(
            (coverage) => coverage.metal_lease_uuid === leaseUuid && coverage.temporal_status === "future",
        ),
    );
}
